import MapMainController from './map-controller';
import MapMainDirective from './map-directive';
import MapRouteConfig from './map.route';

import equipmentListModule from './view/equipment/equipment.module.js';
import mapEquipmentModule from './view/map/map-equipment.module';
import MapEquipmentPopupDirective from './popup/map-popup.component';
import MapSearchBarDirective from './components/map-search-bar.component';
import MapService from './map.service';

import MapHoverPopupComponent from './components/map-hover-popup/map-hover-popup.component';

const mapModule = angular.module('app.map', [
  equipmentListModule,
  mapEquipmentModule,

  //THIRD PARTY
  'ui.router',
  'ui.bootstrap',
  'ui.router',
  'ncy-angular-breadcrumb',
  'gettext'
]);

mapModule
  .config(MapRouteConfig)

  .controller('MapMainController', MapMainController)

  .directive('mapMain', MapMainDirective)
  .directive('mapSearchBar', MapSearchBarDirective)
  .directive('mapEquipmentPopup', MapEquipmentPopupDirective)
  .component('mapHoverPopup', MapHoverPopupComponent)
  .service('mapService', MapService);

export default mapModule.name;
